module.exports = __webpack_public_path__ + "static/media/just-the-job.3f747dab.svg";